module.exports = __webpack_public_path__ + "static/media/tramites-8.92da12ee.png";